var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-navigation-drawer',{attrs:{"permanent":true,"width":"270","app":"","color":"#E7F9F7"}},[_vm._t("basic"),_vm._v(" "),_vm._t("optional")],2)}
var staticRenderFns = []

export { render, staticRenderFns }